import type { ListParams } from '../type';
import baseKey from './_baseKey';

const spaceDomainKey = (spaceSubDomains?: string[]) =>
  baseKey.domainKey('space', spaceSubDomains);

/**
 * 공간 관련 쿼리키 제너레이터
 */
const spaceKey = {
  /**
   * @returns 공간 도메인 기본 쿼리키 (getter)
   * @example ['space']
   */
  domain() {
    return spaceDomainKey();
  },
  /**
   * @returns 공간 유형 프리셋 리스트 쿼리키
   * @example ['space', 'preset', 'list', 'all']
   */
  presetList() {
    return [...baseKey.listKey(spaceDomainKey(['preset']), 'all')];
  },
  /**
   * @param listParams 리스트 파라미터
   * @returns 스크롤 방식의 공간유형 카테고리 리스트 쿼리키
   * @example ['space', 'category', 'list', 'scroll', {...listParams}]
   */
  categoryListByScroll(listParams: ListParams) {
    const coreKey = baseKey.listKey(spaceDomainKey(['category']), 'scroll');
    return listParams ? [...coreKey, listParams] : coreKey;
  },
};

export default Object.freeze(spaceKey);
